import { createApp } from "vue";
import router from "@/router";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./style.less";
import { Popup } from "vant";
import "vant/es/dialog/style";
import "vant/es/toast/style";
import "vant/es/search/style";
import "vant/es/tabs/style";
import "vant/es/divider/style";

// import VConsole from 'vconsole';
import { getQueryString, getQueryStringByKey } from "@/utils";
import authStore from "@/store/AuthStore";

// new VConsole({theme: 'dark'});
const pinia = createPinia();
const renderView = () => {
  const app = createApp(App);
  app.use(router);
  app.use(pinia);
  app.use(Popup);
  app.mount("#app");
};
const token = authStore.getToken();
if (!token) {
  const code = getQueryStringByKey("code");
  if (!code) {
    authStore
      .getAuthCode()
      .then((res) => {
        const wxLoginUrl = new URL(res.url);
        const wxLoginUrlQs = getQueryString(wxLoginUrl.search);
        if (wxLoginUrlQs) {
          wxLoginUrlQs.redirect_uri = encodeURIComponent(
            `${window.location.origin.replace("http:", "https://")}/${
              window.location.hash
            }`
          );
          wxLoginUrl.search = Object.keys(wxLoginUrlQs).reduce(
            (pre: string, next: string) => {
              if (pre) {
                return `${pre}&${next}=${wxLoginUrlQs[next]}`;
              } else {
                return `${next}=${wxLoginUrlQs[next]}`;
              }
            },
            ""
          );
          renderView();
          window.location.replace(wxLoginUrl.toString());
        } else {
          renderView();
          window.location.replace(res.url);
        }
      })
      .catch(() => {
        renderView();
      });
  } else {
    renderView();
  }
} else {
  renderView();
}
